// This is a type safe includes function
// https://fettblog.eu/typescript-array-includes/
export function includes<T extends U, U>(list: readonly T[], el: U): el is T {
  return list.includes(el as T);
}
